import React from "react";
import { Truck, MapPin, Users, Timer } from "lucide-react";
import DashboardMetricCard from "../DashboardMetricCard";
import MetricValueWithExternal from "../MetricValueWithExternal";
import { useEntregaContext } from "./EntregaContext";

const ResumoEntregas: React.FC = () => {
  const { data, isLoading } = useEntregaContext();
  return (
    <section className="space-y-2" aria-labelledby="dashboard-resumo-entregas">
      <h2
        id="dashboard-resumo-entregas"
        className="text-lg font-semibold text-neutral-800"
      >
        Resumo de Entregas
      </h2>
      <div className="xs:grid-cols-2 grid grid-cols-1 gap-3 sm:gap-4 md:grid-cols-3 lg:grid-cols-4 lg:gap-6">
        <DashboardMetricCard
          accent="entrega"
          icon={<Truck aria-hidden />}
          label="Entregas Finalizadas"
          isLoading={isLoading}
          value={
            <MetricValueWithExternal
              value={data?.totalEntregasFinalizadas ?? 0}
              external={data?.totalEntregasExternasFinalizadas}
            />
          }
        />
        <DashboardMetricCard
          accent="entrega"
          icon={<Timer aria-hidden />}
          label="Tempo Médio"
          isLoading={isLoading}
          tabularValue
          value={data?.tempoMedio ?? "00:00:00"}
        />
        <DashboardMetricCard
          accent="entrega"
          icon={<Users aria-hidden />}
          label="Entregadores"
          isLoading={isLoading}
          value={data?.quantidadeEntregadores ?? 0}
        />
        <DashboardMetricCard
          accent="entrega"
          icon={<MapPin aria-hidden />}
          label="Em Entrega"
          isLoading={isLoading}
          value={data?.totalEntregasEmAndamento ?? 0}
        />
      </div>
    </section>
  );
};

export default ResumoEntregas;
